import { largeNumberDisplay } from '@/utils/helpers';

export default {
  props: {
    mode: {
      type: String,
      required: true,
    },
    number: {
      type: Number,
      required: true,
    },
  },
  computed: {
    numberDisplay() {
      return largeNumberDisplay(this.number);
    },
    classModifiers() {
      return {
        'market-shares-ownership': true,
        [`market-shares-ownership--${this.theme}`]: this.theme,
        'market-shares-ownership--yes': this.mode === 'yes',
        'market-shares-ownership--no': this.mode === 'no',
      };
    },
  },
  methods: {
    onClickNumber() {
      this.$emit('click');
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/market/market-shares-ownership/market-shares-ownership.js